import { isEmpty, isEqual, get, trim, compact } from 'lodash';
import { flow, map, take, uniqWith } from 'lodash/fp';
import { AUTOCOMPLETE_STORAGE_KEY, LOCATION_STORAGE_KEY } from '../constants';

export const MAX_LOCAL_STORAGE = 40;

export const storeQuery = (
    searchQuery,
    storeKey = AUTOCOMPLETE_STORAGE_KEY,
) => {
    let searchHistory = localStorage.getItem(storeKey);

    if (!isEmpty(searchHistory)) {
        searchHistory = searchHistory.split(',');

        searchHistory.unshift(searchQuery);
    } else {
        searchHistory = [searchQuery];
    }

    const autocompleteHistory = flow(
        map(trim),
        compact,
        uniqWith((val, otherval) => {
            if (storeKey === LOCATION_STORAGE_KEY) {
                const parsedVal = JSON.parse(val.replace(/;/g, ','));
                const parsedOtherval = JSON.parse(otherval.replace(/;/g, ','));

                return isEqual(
                    get(parsedVal, 'value'),
                    get(parsedOtherval, 'value'),
                );
            }

            return isEqual(val, otherval);
        }),
        take(MAX_LOCAL_STORAGE),
    )(searchHistory);

    localStorage.setItem(storeKey, autocompleteHistory);
};
